/**
 * La cuarta tarjeta de "Tus herramientas" se pinta sola con lo último que salió.
 *
 * Consume cards.the-vault.mx/api/updates/latest — el mismo endpoint que los
 * banners del mega menú, alimentado por `lib/updates.ts` en CardVault, así que
 * está al día en cuanto se deploya una funcionalidad. Sin cron y sin que nadie
 * tenga que acordarse de editar el theme.
 *
 * Mejora progresiva: la tarjeta ya viene pintada desde Liquid con un texto de
 * respaldo que lleva al changelog. Si el endpoint no contesta, se queda como
 * está — nunca un hueco ni una tarjeta vacía.
 *
 * Construye nodos con textContent, nunca innerHTML: el contenido es remoto.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://cards.the-vault.mx/api/updates/latest';

  /*
   * El endpoint devuelve las 3 más recientes de TODAS las audiencias, y la
   * primera puede ser de tienda. Este home es de compradores por diez a uno y
   * la sección ya lleva dos tarjetas para tiendas, así que se salta la etiqueta
   * que diga el theme (por defecto "Tiendas") y toma la primera que sí le
   * hable a quien está mirando. Si todas son de esa etiqueta, se usa la primera
   * antes que no decir nada.
   */
  function elegir(updates, excluida) {
    if (!updates.length) return null;
    if (!excluida) return updates[0];
    var buscada = excluida.toLowerCase();
    for (var i = 0; i < updates.length; i++) {
      var tag = (updates[i].tag || '').toLowerCase();
      if (tag !== buscada) return updates[i];
    }
    return updates[0];
  }

  function pintar(tarjeta, update) {
    // Solo destinos absolutos de nuestro dominio o rutas del propio sitio.
    var href = String(update.link || '');
    if (href.indexOf('https://cards.the-vault.mx') !== 0 && href.indexOf('/') !== 0) return;

    var campo = function (nombre) { return tarjeta.querySelector('[data-uf="' + nombre + '"]'); };
    var poner = function (nombre, texto) {
      var nodo = campo(nombre);
      if (nodo && texto) nodo.textContent = texto;
    };

    poner('emoji', update.emoji);
    poner('titulo', update.title);
    poner('texto', update.summary);
    tarjeta.href = href;

    // La métrica debe decir QUÉ funcionalidad se clicó, no "la cuarta tarjeta":
    // el destino cambia solo cada vez que sale algo nuevo.
    if (update.feature) tarjeta.dataset.vaultDestino = 'Última función: ' + update.feature;
  }

  function init() {
    var tarjeta = document.querySelector('[data-vault-ultima-funcion]');
    if (!tarjeta) return;

    fetch(ENDPOINT)
      .then(function (respuesta) {
        if (!respuesta.ok) throw new Error('HTTP ' + respuesta.status);
        return respuesta.json();
      })
      .then(function (datos) {
        var update = elegir((datos && datos.updates) || [], tarjeta.dataset.vaultExcluirEtiqueta);
        if (update) pintar(tarjeta, update);
      })
      .catch(function () {
        /* sin red o endpoint caído: se queda el respaldo que pintó Liquid */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
